module.exports = __webpack_public_path__ + "static/media/logo.525dfdd4.png";